module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/29muCq/images/cover.jpg?1685327560572",
      "alt": "This image is the cover for the book Wounded Hearts, Wounded"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Wounded Hearts, Wounded\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Wounded: Book One")])])]), _c('p', [_vm._v("Zane Ashford’s stint in the NYPD comes to an abrupt halt when he is injured in the line of duty. After waking up partially blind in one eye, all he wants to do is crawl into a hole, but his friends and family won’t leave him alone. Reluctantly, he lets his best friend talk him into time away on a ranch in Montana. But the moment he gets there and meets Cyrus Abrams, Zane begins to contemplate murder.")]), _vm._v(" "), _c('p', [_vm._v("Cyrus Abrams is vulgar, ornery, stuck in his ways, and not about to change for anyone, no matter how good Zane Ashford looks in those jeans. The more they lock horns, the more Cyrus begins to see Zane in a whole new light. But Cyrus has a past, one that left him in big trouble and more broken than he cares to admit—a past no one told Zane about. Cyrus fears that when Zane finds out, everything will come to a screeching halt.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Remmy Duchene, BLMorticia\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0